export enum AssetCommandEnums {
  TimerProfile = 1,
  DimmingProfile = 2,
  LuminanceProfile = 3,
  DayLightProfile = 4,
  RainProfile = 5,
  DayLightHarvest = 6,
  getLightingZone = 7,
  getTriggerZone = 8,
  getLightOverride = 9,
  getLightIntensity = 10,
  getSoftDimming = 11,
  getTimeDelay = 12,
  getLightInstallDate = 13,
  getMotionSensitivity = 14,
  getPhotoSensing = 15,
  getRainSensing = 16,
}
